<template>
  <li>
    <div class="product_img">
      <a
        :href="product.outlink"
        target="_blank"
      ><img :src="product.img_url"></a>
    </div>
    <div class="product_text_info">
      <p class="product_title">
        <a
          :href="product.outlink"
          target="_blank"
        ><span
          class
        >{{ product.item_name }}</span> / <span
          class
        ><template
          v-if="isDoubleX(product.item_sku)"
        >{{ product.count * 3 }}{{ product.display }} ({{ product.count }}세트)</template><template
          v-else
        >{{ product.count }}{{ product.display }}</template></span></a>
      </p>
      <div class="hashtag_list">
        <span
          v-for="hash in product.item_hashes"
          :key="hash"
        >#{{ hash }} </span>
      </div>
    </div>
  </li>
</template>

<script>
import doubleXMixin from '@/components/global/doublex-mixin';

export default {
  name: 'ProductItemInfoDetail',
  mixins: [doubleXMixin],
  props: {
    product: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
  },
  created() {
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/mypacks/detail/partial/recent-part/ProductsItemInfoDetail.vue